module.exports = __webpack_public_path__ + "img/spbu5.aac31dad.png";